import React, { useState, useEffect } from 'react';
import classes from '../Preguntas.css';

export default function PreguntaSiNo({
  defaultValue,
  numeroPregunta,
  onChangeRespuesta,
  onElegir,
  idSI,
  idNO,
  esObligatoria
}) {
  // Convierte el defaultValue a formato interno esperado (ej: "23_Si")
  const mapDefaultValue = (valor) => {
    if (valor === `${idSI}` || valor === `${idSI}_Si`) return `${idSI}_Si`;
    if (valor === `${idNO}` || valor === `${idNO}_No`) return `${idNO}_No`;
    return '';
  };

  const [selectedValue, setSelectedValue] = useState(mapDefaultValue(defaultValue));

  // 🔁 Actualizar estado si defaultValue cambia desde el padre
  useEffect(() => {
    const mapped = mapDefaultValue(defaultValue);
    if (mapped !== selectedValue) {
      setSelectedValue(mapped);
    }
  }, [defaultValue, idSI, idNO]);

  const elegir = (value) => {
    if (value !== selectedValue) {
      setSelectedValue(value);
    }
    onElegir?.();
  };

  useEffect(() => {
    const tieneContenido = selectedValue !== '';
    const [id, respuesta] = selectedValue.split('_');
    const respuestaObj = {
      numeroPregunta,
      tieneContenido,
      contenido: [id, respuesta],
      id,
      esObligatoria
    };
    onChangeRespuesta(respuestaObj);
  }, [selectedValue]);

  const opciones = [
    { value: `${idSI}_Si`, label: 'Sí' },
    { value: `${idNO}_No`, label: 'No' }
  ];

  return (
    <div className={classes.sino}>
      {opciones.map((op) => (
        <button
          key={op.value}
          type="button"
          className={selectedValue === op.value ? classes.sel : ''}
          aria-pressed={selectedValue === op.value}
          onClick={() => elegir(op.value)}
        >
          {op.label}
        </button>
      ))}
    </div>
  );
}
